import type { VFC } from "react";
import ReactPaginate from "react-paginate";

import { KibelaSymbol } from "./kibela_symbol";

export const Pagination: VFC<{
  totalPages: number;
  currentPage: number;
  onPageChange: (selectedItem: { selected: number }) => void;
  onClick?: (clickEvent: {
    index: number | null;
    selected: number;
    nextSelectedPage: number | undefined;
    event: object;
    isPrevious: boolean;
    isNext: boolean;
    isBreak: boolean;
    isActive: boolean;
  }) => boolean | number | void;
}> = ({ totalPages, currentPage, onPageChange, onClick }) => {
  if (totalPages > 1) {
    return (
      <ReactPaginate
        pageCount={totalPages}
        pageRangeDisplayed={4}
        forcePage={currentPage}
        breakLabel={""}
        onPageChange={onPageChange}
        marginPagesDisplayed={0}
        previousLabel={<KibelaSymbol id="prev" />}
        nextLabel={<KibelaSymbol id="next" />}
        containerClassName="pagination"
        previousClassName="prev"
        pageClassName="page"
        activeClassName="is-page-current"
        disableInitialCallback
        onClick={onClick}
      />
    );
  } else {
    return null;
  }
};
